// Service-bucket operational capability toggle (v1.0).
//
// Source: docs/planning/service_bucket.md §5.4.
//
// Flips `organizations.services_enabled` — gates Board, Requests,
// Calendar, and dispatch APIs. Does not gate offerings catalog CRUD.
// Saved via `admin_set_services_enabled` RPC (enablement requires ≥1
// active service_dispatcher or service_admin on the org).

import type { Dispatch, SetStateAction } from "react";

export function OrgSettingsSectionService(props: {
  servicesEnabled: boolean;
  setServicesEnabled: Dispatch<SetStateAction<boolean>>;
  saving: boolean;
  onSave: () => void | Promise<void>;
}) {
  const { servicesEnabled, setServicesEnabled, saving, onSave } = props;
  return (
    <div className="pt-2 border-t border-gray-100">
      <div className="mb-3 rounded-lg border border-violet-200 bg-violet-50 p-3">
        <p className="text-xs font-semibold text-violet-900">Service bucket (operational capability)</p>
        <p className="mt-1 text-[11px] text-violet-900/80">
          When enabled, this organization runs the operational Service department — Board, inbound
          requests, calendar, rigs, technicians, map, and dispatch APIs. Offerings catalog and
          opportunity quoting stay available separately. Enabling requires at least one active{" "}
          <span className="font-mono">service_dispatcher</span> or{" "}
          <span className="font-mono">service_admin</span> on the org. Default: disabled.
        </p>
        <label className="mt-2 inline-flex items-center gap-2 text-xs text-violet-900">
          <input
            type="checkbox"
            checked={servicesEnabled}
            onChange={(e) => setServicesEnabled(e.target.checked)}
            disabled={saving}
          />
          Service department enabled (operational bucket visible)
        </label>
        <div className="mt-2">
          <button
            type="button"
            onClick={() => void onSave()}
            disabled={saving}
            className="px-3 py-1.5 rounded-lg bg-violet-600 text-white text-xs hover:bg-violet-700 disabled:opacity-50"
          >
            {saving ? "Saving..." : "Save service capability"}
          </button>
        </div>
      </div>
    </div>
  );
}
